import { inject, Injectable } from '@angular/core';
import { Store } from '@sama/app-state';
import { isDefined } from '@sama/js-core';
import { flatMap } from '@sama/micro-dash';
import { InjectableSuperclass } from '@sama/ng-core';
import { values } from 'lodash';
import { filter, map, switchMap } from 'rxjs/operators';
import { ObjectState } from '../../../cross-team-shared/annotation/shared/state/object-state';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';
import { getVisibilityState } from '../utils/shape-visibility-utils';

@Injectable()
export class ObjectVisibilityService extends InjectableSuperclass {
  private taskWorkspaceStore = inject(TaskWorkspaceStore);

  getVisibilityState(objectStore: Store<ObjectState>, frameNumber: number) {
    return objectStore.$.pipe(
      filter(isDefined),
      switchMap((object) => this.getNestedShapes$(object.index)),
      map((nestedShapes) => {
        const allVisible = nestedShapes.every(
          (nestedShape) =>
            getVisibilityState(
              // @ts-ignore -- fix me
              nestedShape,
              frameNumber,
            ) === 1,
        );
        if (allVisible) {
          return 1;
        }
        const allInvisible = nestedShapes.every(
          (nestedShape) =>
            getVisibilityState(
              // @ts-ignore -- fix me
              nestedShape,
              frameNumber,
            ) === 0,
        );
        return allInvisible ? 0 : 0.5;
      }),
    );
  }

  private getNestedShapes$(objectId: number) {
    const outputAnnotationInfo$ = this.taskWorkspaceStore(
      'outputAnnotationInfo',
    ).$;

    const nestedShapes$ = outputAnnotationInfo$.pipe(
      map((outputAnnotationInfo) =>
        flatMap(values(outputAnnotationInfo), (shapeInfo) =>
          // @ts-ignore -- fix me
          values(shapeInfo.shapes).filter(
            // @ts-ignore -- fix me
            (shape) => shape.parentId === objectId,
          ),
        ),
      ),
    );
    return nestedShapes$;
  }
}
